<template>
    <div :class="{container: true, noscroll: modalVisable}">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img :src="item">
            <div class="activityImg" v-if="activity.isShow && index == 0">
                <img :src="activity.H5activeImg">
            </div>
        </div>
        <div class="section" v-for="(item, index) in btnImgList" :key="index">
            <img :src="item">
            <div class="btn" @click="showModal(index)" v-if="index % 2 == 0"></div>
        </div>
        <div class="section" v-for="(item, index) in imgList1" :key="index">
            <img :src="item">
        </div>
        <button class="footer" @click="JumpFn">
            <img :src="H5footerImg">
        </button>
        <div
            :class="{'modal-container': true, active: modalVisable}"
        >
            <div
                :class="{'layer': true, active: modalVisable}"
            />
            <div class="modal">
                <div

                    :class="{'modal-content': true, active: modalVisable}"
                >
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div class="title">
                        {{ sortStageList[current] && sortStageList[current].title }}
                    </div>
                    <div class="scroll-content" v-if="sortStageList[current]">
                        <div class="detail" v-for="(item, i) in sortStageList[current].detail" :key="i">
                            <div class="d-title">
                                {{item.title}}
                            </div>
                            <div class="d-center">
                                <div class="d-name">
                                    <img class="d-img" :src="iconImg">{{item.name}}
                                </div>
                                <div class="d-desc">
                                    {{item.desc}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './list';
import activity from '../../../common/activity';

export default {
    data() {
        return {
            activity,
            iconImg:"https://s21.lgstatic.com/growth/activity/20210315/1615794992222.png",
            List:List,
            selfTop: 0,
            current: 0,
            modalVisable: false,
            imgList:[],
            btnImgList:[],
            imgList1: [],
            sortStageList: [],
            H5footerImg:""
        }
    },
    mounted() {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1s2b'});
        },500)
        this.sortStageList = this.List.data.sortStageList
        this.H5footerImg = this.List.data.H5footerImg
        this.imgList1 = this.List.data.imgList1
        this.btnImgList = this.List.data.btnImgList
        this.imgList = this.List.data.imgList
    },
    methods: {
        JumpFn() {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s2b',
                'button_name': '领取详细课程大纲'
            });
            //跳转支付页
            window.location.href = "https://t.lagou.com/aR95RvRxcY24B";
        },
        closeModal() {
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);

        },
        showModal(index) {
            let val = '';
            if(index == 2) {
                val = 1
            } else if (index == 4) {
                val = 2
            } else if (index == 6) {
                val = 3
            } else {
                val = 0
            }
            this.fixedBody();
            this.current = val;
            this.modalVisable = true;
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    padding-bottom: 130px;
}
.section {
    position: relative;
    width: 100%;
    img {
        width: 100%;
        font-size: 0;
        display: block;
    }
    .activityImg {
        position: absolute;
        z-index: 11;
        top: 0;
        right: 0;
        width: 157px;
        height: 158px;
        img {
            width: 100%;
        }
    }
}
.btn {
    position: absolute;
    right: 70px;
    top: 45px;
    width: 155px;
    height: 80px;
    z-index: 2;
}
.footer {
    position: fixed;
    background-color:transparent;
    border: none;
    bottom: -1px;
    z-index: 999;
    width: 100%;
    img {
        width: 100%;
        display: block;
    }
}

.layer {
        position: fixed;
        z-index: 1;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
         display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 119px;
        z-index: 3;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s;
            &.active {
                opacity: 1;
                height: 962px;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;

            margin-right: 45px;
            box-sizing: border-box;
        }

        .close {
            width: 52px;
            height: 52px;
            background: url("https://s21.lgstatic.com/growth/activity/20210315/1615791918686.png") no-repeat center;
            background-size: 42px 42px;
            position: absolute;
            right: 18px;
            top: 18px;
            border-radius: 50%;
        }

        .title {
            margin-top: 82px;
            width: 100%;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
        }

        .scroll-content {
            height: 790px;
            overflow-y: scroll;
            .detail {
                width: 100%;
                display: flex;
                margin-bottom: 30px;
                .d-title {
                    width: 125px;
                    text-align: center;
                    font-size: 26px;
                    padding-left: 20px;
                    color: #105FE6;
                }
                .d-center {
                    flex: 1;
                    padding-right: 10px;
                    .d-name {
                        font-size: 25px;
                        color:#333;
                        font-weight: 500;
                        .d-img {
                            width: 3px;
                            height: 29px;
                            vertical-align: middle;
                            padding-right: 18px;
                            margin-top: -4px;
                        }
                    }
                    .d-desc {
                        font-size: 23px;
                        color:#666;
                        padding-left: 24px;
                    }
                }
            }
        }
    }
</style>